/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Start_TitleInputs */

const en_gc_guides_start_title = /** @type {(inputs: Gc_Guides_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft XLSX guide: open, edit and save a workbook`)
};

const zh_gc_guides_start_title = /** @type {(inputs: Gc_Guides_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft XLSX 指南：打开、编辑与保存工作簿`)
};

/**
* | output |
* | --- |
* | "GridCraft XLSX guide: open, edit and save a workbook" |
*
* @param {Gc_Guides_Start_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_start_title = /** @type {((inputs?: Gc_Guides_Start_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Start_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_start_title(inputs)
	return zh_gc_guides_start_title(inputs)
});
export { gc_guides_start_title as "gc.guides.start.title" }